import axios from 'axios';
import React, { useState, useEffect } from 'react';

const Update = ({ setIsLoading, setActiveMenuItem }) => {

    //************************************************** Getting the product data ************************************************ */
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedColors, setSelectedColors] = useState([]);
    const [imgSrcArray, setImgSrcArray] = useState(Array(8).fill(null));
    const [sizes, setSizes] = useState({XS: false, S: false, M: false, L: false, XL: false, XXL: false, XXXL: false});
    const [multiSize, setMultiSize] = useState(false);


    useEffect(() => { setIsLoading(true); setActiveMenuItem('Mise à jour'); axios.get(`${baseUrl}/product`).then(({ data }) => { setImgSrcArray(JSON.parse(data[0].imgSrcArray)); setSelectedColors(JSON.parse(data[0].colors)); setSizes(JSON.parse(data[0].sizes)); setProduct_name(data[0].product_name); setBrand(data[0].brand); setDescription(data[0].description); setPrice(data[0].price); setShipping_fee(data[0].shipping_fee); setMultiSize(data[0].multi_tailles)}).then(() => setIsLoading(false)).catch((err) => { console.log(err); setIsLoading(false); handleError('Problème de communication avec le serveur veuillez réessayer.')}) }, [])
//************************************************** ***************************** ************************************************ */
    //The colors
    const colors = ["Black", "Gray", "Red", "Green", "Blue", "Yellow", "Purple", "Pink", "Orange", "Brown", "Cyan", "Magenta", "Olive", "Teal", "Navy", "Maroon", "Indigo", "Salmon", "Turquoise"];

    const handleCheckboxChange = (color) => {
        setSelectedColors((prevSelectedColors) => {
            if (prevSelectedColors.includes(color)) {
                // If color is already selected, remove it
                return prevSelectedColors.filter((selectedColor) => selectedColor !== color);
            } else {
                // If color is not selected, add it
                return [...prevSelectedColors, color];
            }
        });
    };

    

    const [hoveredImage, setHoveredImage] = useState(null);

    const handleSizeChange = (size) => {
        setSizes((prevSizes) => ({ ...prevSizes, [size]: !prevSizes[size] }));
    };

    // *********************************************** Images upload ******************************************************
    const cloudName = process.env.REACT_APP_CLOUDNAME;
    const uploadPreset = process.env.REACT_APP_UPLOAD_PRESET



    const handleImageUpload = (e, index) => {
        setIsLoading(true)
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', uploadPreset);

        axios.post(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, formData)
            .then(res => {
                const updatedImgSrcArray = [...imgSrcArray];
                updatedImgSrcArray[index - 1] = res.data.secure_url;
                setImgSrcArray(updatedImgSrcArray);
                setIsLoading(false);
            })
            .then(() => handleSuccess("image importée avec succès !!"))
            .catch(err => {
                console.log(err);
                setIsLoading(false)
                handleError("Erreur d'importation d'image !! Vérifiez votre connection internet")
            });
    };

    //************************************************** The variables *************************************************** */
    const [product_name, setProduct_name] = useState('');
    const [brand, setBrand] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [shipping_fee, setShipping_fee] = useState('');

    var uploadedData = {
        product_name: product_name,
        brand: brand,
        description: description,
        price: price,
        shipping_fee: shipping_fee,
        colors: JSON.stringify(selectedColors),
        multi_tailles: multiSize,
        sizes: JSON.stringify(sizes),
        imgSrcArray: JSON.stringify(imgSrcArray)
    }

    // console.log(uploadedData)

    //****************************************** Error handling ********************************************************** */

    const [error, setError] = useState(null);
    const [showClass, setShowClass] = useState("");

    const handleError = (str) => {
        setError(str);
        setShowClass('show')
        setTimeout(() => {
            setError(null);
            setShowClass('')
        }, 5000);
    };
    //****************************************** Success handling ******************************************************* */
    const [success, setSuccess] = useState(null);
    const [successClass, setSuccessClass] = useState("");

    const handleSuccess = (str) => {
        setSuccess(str);
        setSuccessClass('showSuccess')
        setTimeout(() => {
            setSuccess(null);
            setSuccessClass('')
        }, 5000);
    };


    //******************************************** API REQUEST ************************************************************* */


    const hundleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true)
        if (product_name?.length && brand?.length && description?.length && price && typeof (price) !== "string" && shipping_fee || shipping_fee === 0 && typeof (shipping_fee) !== "string" && selectedColors.length && !imgSrcArray.includes(null)) {
            if (!multiSize || Object.values(sizes).includes(true)) {
                axios.put(`${baseUrl}/product/1`, uploadedData).then(() => { handleSuccess("Produit ajouté avec succès !!");}).catch((err) => { console.log(err); handleError('Problème de communication avec le serveur veuillez réessayer.') }).finally(() => {
                    setIsLoading(false);
                });
            }
            else {
                handleError('Tous les champs avec * sont obligatoires.');
                setIsLoading(false);
            }
        }
        else {
            handleError('Tous les champs avec * sont obligatoires.');
            setIsLoading(false);
        }
    }

    return (
        <section className="checkout spad">
            <div className={`error-message ${showClass}`}>

                <div className="close-button" onClick={() => { setError(null); setShowClass('') }}>
                    X
                </div>
                <div className="message-content">{error}</div>
            </div>
            <div className={`success-message ${successClass}`}>

                <div className="close-buttonSuccess" onClick={() => { setSuccess(null); setSuccessClass('') }}>
                    X
                </div>
                <div className="message-contentSuccess">{success}</div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h6 className="coupon__link">
                            <span className="icon_folder-add"></span> Ajouter un nouveau produit.
                        </h6>
                    </div>
                </div>
                <form className="checkout__form">
                    <div className="row">
                        <div className="col-lg-5">
                            <h5>DÉTAIL DU PRODUIT</h5>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="checkout__form__input">
                                        <p>Nom du produit <span>*</span></p>
                                        <input type="text" value={product_name} onChange={(e) => setProduct_name(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="checkout__form__input">
                                        <p>Marque <span>*</span></p>
                                        <input type="text" value={brand} onChange={(e) => setBrand(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="checkout__form__input">
                                        <p>Description <span>*</span></p>
                                        <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="checkout__form__input">
                                        <p>Prix (DT)<span>*</span></p>
                                        <input type="text" value={price} onChange={(e) => setPrice(isNaN(parseFloat(e.target.value)) ? '' : parseFloat(e.target.value))} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="checkout__form__input">
                                        <p>Frais de livraison (DT)<span>*</span></p>
                                        <input type="text" value={shipping_fee} onChange={(e) => setShipping_fee(isNaN(parseFloat(e.target.value)) ? '' : parseFloat(e.target.value))} />
                                    </div>
                                </div>

                                {/* -------------------------------- */}
                                <div className="product__details__widget checkout__form__input col-lg-12">
                                    <p>Couleurs disponibles<span>*</span></p>
                                    <ul>
                                        <li>
                                            <div className="color__checkbox">
                                                <label htmlFor="White">
                                                    <input
                                                        type="checkbox"
                                                        name="color__radio"
                                                        id="White"
                                                        checked={selectedColors.includes("White")}
                                                        onChange={() => handleCheckboxChange("White")}
                                                    />
                                                    <span className="checkmark border" style={{ backgroundColor: "White" }}></span>
                                                </label>
                                                {colors.map((color, index) => (
                                                    <label key={index} htmlFor={color}>
                                                        <input
                                                            type="checkbox"
                                                            name="color__radio"
                                                            id={color}
                                                            checked={selectedColors.includes(color)}
                                                            onChange={() => handleCheckboxChange(color)}
                                                        />
                                                        <span className="checkmark" style={{ backgroundColor: color }}></span>
                                                    </label>
                                                ))}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                {/* -------------------------------- */}
                                <div className="product__details__widget col-lg-12 modifiedPolice">
                                    <p>Article multi-tailles<span>*</span></p>
                                    <ul>
                                        <li>
                                            <div className="size__btn">
                                                <label htmlFor="yes-btn" className={multiSize ? "active" : ""} onClick={() => { setMultiSize(true); }}>
                                                    <input type="radio" id="yes-btn" />
                                                    Oui
                                                </label>
                                                <label htmlFor="no-btn" className={!multiSize ? "active" : ""} onClick={() => { setMultiSize(false); setSizes({ XS: false, S: false, M: false, L: false, XL: false, XXL: false, XXXL: false }); }}>
                                                    <input type="radio" id="no-btn" />
                                                    Non
                                                </label>
                                            </div>
                                        </li>
                                    </ul>

                                    {multiSize && <p>Tailles disponibles<span>*</span></p>}
                                    {multiSize && (
                                        <ul>
                                            <li>
                                                <div className="size__btn">
                                                    {Object.entries(sizes).map(([size, selected]) => (
                                                        <label key={size} htmlFor={`${size}-btn`} className={selected ? "active" : ""} onClick={() => { handleSizeChange(size); }}>
                                                            <input type="checkbox" />
                                                            {size.toLowerCase()}
                                                        </label>
                                                    ))}
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="checkout__order">
                                <h5>Images du produit</h5>
                                <div className="row">
                                    {Array.from({ length: 4 }, (_, i) => i + 1).map((imageIndex) => (
                                        <div key={imageIndex} className="col-lg-6 col-md-6 col-sm-6">
                                            <div className="checkout__form__input preview">
                                                <p>{`Image 0${imageIndex}`} <span>*</span></p>
                                                <input
                                                    type="file"
                                                    id={`productImage_${imageIndex}`}
                                                    accept="image/*"
                                                    className="form-control"
                                                    onChange={(e) => { handleImageUpload(e, imageIndex) }}
                                                    onMouseEnter={() => setHoveredImage(imageIndex)}
                                                    onMouseLeave={() => setHoveredImage(null)}
                                                    onTouchStart={() => setHoveredImage(imageIndex)}
                                                    onTouchEnd={() => setHoveredImage(null)}
                                                />
                                                {hoveredImage === imageIndex && imgSrcArray[imageIndex - 1] && (
                                                    <div className="image-preview-popup">
                                                        <img src={imgSrcArray[imageIndex - 1]} alt={`Image ${imageIndex} Preview`} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {Array.from({ length: 4 }, (_, i) => i + 5).map((thumbIndex) => (
                                        <div key={thumbIndex} className="col-lg-6 col-md-6 col-sm-6">
                                            <div className="checkout__form__input preview">
                                                <p>{`Thumbnail 0${thumbIndex - 4}`} <span>*</span></p>
                                                <input
                                                    type="file"
                                                    id={`productThumb_${thumbIndex}`}
                                                    accept="image/*"
                                                    className="form-control"
                                                    onChange={(e) => { handleImageUpload(e, thumbIndex) }}
                                                    onMouseEnter={() => setHoveredImage(thumbIndex)}
                                                    onMouseLeave={() => setHoveredImage(null)}
                                                    onTouchStart={() => setHoveredImage(thumbIndex)}
                                                    onTouchEnd={() => setHoveredImage(null)}
                                                />
                                                {hoveredImage === thumbIndex && imgSrcArray[thumbIndex - 1] && (
                                                    <div className="image-preview-popup">
                                                        <img src={imgSrcArray[thumbIndex - 1]} alt={`Thumbnail ${thumbIndex} Preview`} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className='site-btn' onClick={(event) => { hundleSubmit(event) }}>
                                    Ajouter le produit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Update;
